import { NgModule, APP_INITIALIZER } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import {
    HttpClient,
    provideHttpClient,
    withInterceptorsFromDi,
} from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';

/** Components **/
import { GlobalNotification } from './globalnotification';
import { Controlbar } from '../Portal/Blocks/Controlbar/Controlbar';

/** Services **/
import { GlobalNotificationService } from '../Services/GlobalNotificationService';
import {
    TranslationService,
    appInitializerFactory,
} from '../Services/TranslateService';
import { TranslateService } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, '../../assets/i18n/', '.json');
}
@NgModule({
    bootstrap: [GlobalNotification],
    exports: [],
    declarations: [GlobalNotification, Controlbar],
    imports: [
        BrowserModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: createTranslateLoader,
                deps: [HttpClient],
            },
        }),
    ],
    providers: [
        GlobalNotificationService,
        TranslationService,
        TranslateService,
        { provide: 'Claims', useFactory: () => (window as any)['Claims'] },
        {
            provide: APP_INITIALIZER,
            useFactory: (translationService: TranslationService) => () =>
                translationService.loadDevExtremeMessages(),
            multi: true,
            deps: [TranslationService],
        },
        {
            provide: APP_INITIALIZER,
            useFactory: appInitializerFactory,
            deps: [TranslateService, TranslationService],
            multi: true,
        },
        provideHttpClient(withInterceptorsFromDi()),
    ],
})
export class GlobalNotificationModule {}
